import voiceQuestion from './voiceQuestion';
import standardQuestions from '../modules/standardQuestions';
import dbArr from '../db/dbArr.json';
import {
	stopVoiseLisenerAll,
	stopVoiseSpeecAll
} from '../services/LitlModules';
// import { Promise } from "core-js";
let counter = 0,
	arlist = [],
	seler = null,
	audio,
	selectorListQ = [];

const quetionAdd = (vioseSkib, sel, e, prop = false) => {
	if (e) {
		e.preventDefault();
	}

	if (sel) {
		counter = 0;
		switch (sel) {
			case 'tick':
				arlist = dbArr['styles'][0];
				sel = 'tick';
				break;
			case 'cross':
				arlist = dbArr['styles'][1];
				sel = 'cross';
				break;
			case 'heart':
				arlist = dbArr['styles'][2];
				sel = 'heart';
				break;
			case 'flower':
				arlist = dbArr['styles'][3];
				sel = 'flower';
				break;
		}
	}
	const localMute = localStorage.getItem('muteVoise'),
		icon_material_li = document.querySelector('.icon-material_li');

	if (sel) {
		seler = sel;
	}

	if (
		document.querySelectorAll('.tinRightIn').length !== 0 &&
		window.modeloderad
	) {
		counter = document.querySelectorAll('.tinRightIn').length;
	}

	if (counter > arlist.length - 1) {
		arlist = [];
		console.log('ну все !');
		return;
	}
	if (!prop) {
		// stopVoiseLisenerAll();
	}

	if (vioseSkib) {
		return (arlist = []);
	}

	const wrapperTutle = document.querySelector('.wrapperTutle');

	if (wrapperTutle.classList.contains('pps')) {
		wrapperTutle.classList.remove('pps');
	}

	standardQuestions(arlist[counter], seler, counter + 1, prop, arlist.length);

	if (global.appleMode) {
		//  let key = counter;
		voiceQuestion(
			counter + 1,
			seler + 'question' + counter,
			arlist[counter][2],
			prop,
			'quAdd'
		);
	}

	counter++;
};
export default quetionAdd;
